//import components

import React, { useMemo, useEffect, useState } from "react";
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { APIClient } from "../../../helpers/api_helper";
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import { CardBody, Card, Modal, ModalHeader, Alert } from "reactstrap";
import { toast } from 'react-toastify';
import axios from "axios";
const api = new APIClient();
const baseUrl = process.env.REACT_APP_BASE_URL;

interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const ExpDashboard = () => {


    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const [showloader, setshowloader] = useState(true);



    const [modal_center_delete, setModalDelete] = useState(false);
    const [zoomUser, setZoomUser] = useState<any>(null);
    const [bookings, setBookings] = useState<any[]>([]);
    const [sending, setSending] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [joinUrl, setJoinUrl] = useState<string | null>(null);
    const [startUrl, setStartUrl] = useState<string | null>(null);
    const [sentOnce, setSentOnce] = useState(false);
    const [markingCompleted, setMarkingCompleted] = useState<{ [key: string]: boolean }>({});



    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function zoomInitiate(user: any) {
        setZoomUser(user);
        setModalDelete(true);
        removeBodyCss();
    }

    const handleMarkCompleted = async (bookingId: string) => {
        if (!bookingId) return;
        
        setMarkingCompleted({ ...markingCompleted, [bookingId]: true });
        try {
            setshowloader(true);
            const response = await axios.post(`/bookings/mark_booking_completed`, {
                booking_id: bookingId
            });
            setshowloader(false);
            
            if (response.status === 'SUCCESS') {
                toast.success('Booking marked as completed successfully!');
                fetch_expertlisting(); // Refresh the bookings list
            } else {
                toast.error(response.error || 'Failed to mark booking as completed');
            }
        } catch (error: any) {
            setshowloader(false);
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error || 'Failed to mark booking as completed', type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout" }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            toast.error(error.response?.data?.error || 'Failed to mark booking as completed');
        } finally {
            setMarkingCompleted({ ...markingCompleted, [bookingId]: false });
        }
    };

    const handleSendZoomLink = async (userId?: number, email?: string) => {
        if (!zoomUser) return toast.error('No user selected');
        console.log('userId',userId,'email',email)
        setSending(true);
        setEmailSent(false);
        setJoinUrl(null);
        setStartUrl(null);
        try {
            setshowloader(true)
            const res = await axios.post("/accounts/zoom_create",{customer_id: userId, email:email,});
            setshowloader(false)
            console.log('Zoom link sent:', res);
            console.log('Zoom link sent:', res.join_url);
            setEmailSent(true);
            const { join_url, start_url } = res;
            setJoinUrl(join_url);
            setStartUrl(start_url);
            setSentOnce(true);
            fetch_expertlisting();
            toast.success('Zoom link sent successfully!');
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    console.log('Error in stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                    console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                    console.log('An error occurred')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        } finally {
            setSending(false);
        }
    };

    const columns: column[] = useMemo(() => [
        {
            header: '#ID',
            accessorKey: 'id',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Customer Info',
            accessorFn: (row: any) => `${row?.cust?.user?.first_name || ''} ${row?.cust?.user?.email || ''}`,
            enableColumnFilter: false,
            enableSorting: true,
            cell: (info: any) => {
                const row = info.row.original;
                const user = row?.cust?.user;
                return (
                    <div className="d-flex align-items-center">
                        <img
                            src={user?.profile_pic || defaultUserImg}
                            alt="User"
                            width="50"
                            height="50"
                            className="rounded-circle object-fit-cover"
                            style={{ marginRight: '10px' }}
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = defaultUserImg;
                            }}
                        />
                        <div>
                            <div className="fw-medium">{user?.first_name || "No name"}</div>
                            <div className="font-size-12">{user?.email || "No email"}</div>
                        </div>
                    </div>
                );
            }
        },
        {
            header: 'Phone',
            accessorKey: 'cust.user.phone',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Booking Date',
            accessorKey: 'seldate',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Category',
            accessorKey: 'expert.category.name',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Session',
            enableColumnFilter: false,
            enableSorting: true,
            cell: ({ row }: any) => {return `$${row.original?.expert_price} / ${row.original?.exp_session_mins} Mins`},
        },
        {
            header: 'Purpose',
            accessorKey: 'purpose',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Status',
            accessorKey: 'status',
            enableColumnFilter: false,
            enableSorting: true,
            cell: ({ row }) => {
                const status = row.original.status;
                const badgeClass =
                    status === 'failed'
                        ? 'font-size-11 badge-soft-danger badge bg-secondary'
                        : 'font-size-11 badge-soft-success badge bg-secondary';
                return <span className={badgeClass}>{status}</span>;
            },
        },
        {
            header: 'Action',
            id: 'action',
            enableColumnFilter: false,
            enableSorting: false,
            cell: ({ row }) => {
                const booking = row.original;
                const isCompleted = booking.status === 'completed';
                const isBooked = booking.status === 'booked';
                const isMarking = markingCompleted[booking.id] || false;
                
                return (
                    <div className="d-flex gap-2">
                        {isBooked && (
                            <button
                                className="btn btn-sm btn-success"
                                type="button"
                                disabled={isMarking}
                                onClick={() => handleMarkCompleted(booking.id)}
                            >
                                <i className="bx bx-check-circle"></i> {isMarking ? 'Marking...' : 'Mark Completed'}
                            </button>
                        )}
                        {!isCompleted && (
                            <button
                                className="btn btn-sm btn-primary"
                                type="button"
                                onClick={() => zoomInitiate(booking)}
                            >
                                <i className="bx bxs-video"></i> Zoom Initiate
                            </button>
                        )}
                        {isCompleted && (
                            <span className="badge bg-success">Completed</span>
                        )}
                    </div>
                );
            }
        }
    ], []);

    const fetch_expertlisting = async () => {
        try {
            const userinfo_ = localStorage.getItem('authUser');
            const user_role = localStorage.getItem('userole_');
            setshowloader(true)
            const response = await api.get(`/bookings/expert_bookings`, {
                params: {
                    user_id: userinfo_,
                    user_role: user_role
                }
            });
            
            
            if (response.status === 'SENT') {
                setshowloader(false)
                setBookings(response.bookings);
                // setJoinUrl(response.bookings.zoom)
            }
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    console.log('Error in stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                    console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                    console.log('An error occurred')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
    };

    useEffect(() => {
        fetch_expertlisting();
        subscribeToTokenRefresh(() => {
            console.log("🔁 Token refreshed. Re-fetching experts...");
            fetch_expertlisting();
        });
    }, []);

    document.title = "Bookings | BizServe";

    return (
        <div className="page-content">
            <div className="container-fluid">
            
                <Breadcrumbs title="Expert" breadcrumbItem="Expert bookings" />
                {alertMsgg.open && (
            <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
          </div>
                <Card className="rounded-4">
                    <CardBody>
                        <TableContainer
                            columns={columns}
                            data={bookings || []}
                            isGlobalFilter={true}
                            isPagination={true}
                            SearchPlaceholder="Search By Name..."
                            pagination="pagination"
                            paginationWrapper='dataTables_paginate paging_simple_numbers'
                            tableClass="table-bordered dt-responsive table-nowrap w-100 dataTable no-footer dtr-inline"
                        />
                    </CardBody>
                </Card>

                <Modal
                    isOpen={modal_center_delete}
                    toggle={() => setModalDelete(!modal_center_delete)}
                    centered
                    backdrop={'static'}
                    className="rounded-4">
                    <ModalHeader
                        className="py-3 px-4"
                        toggle={() => setModalDelete(!modal_center_delete)}
                    >
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            Zoom Integration Request
                        </div>
                    </ModalHeader>
                    <div className="modal-body">
                        <form>
                            <div className="d-flex justify-content-between">
                                <div className="d-flex align-items-center border-bottom pb-3 mb-2">
                                    <img
                                        src={zoomUser?.cust?.user?.profile_pic || defaultUserImg}
                                        alt="User"
                                        width="40"
                                        height="40"
                                        className="rounded-circle object-fit-cover"
                                        style={{ marginRight: '10px' }}
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = defaultUserImg;
                                        }}
                                    />


                                    {zoomUser && (
                                        <div>
                                            <div className="fw-medium d-flex align-items-center gap-2">
                                                {zoomUser?.cust?.user?.first_name} <i className="bx bx-check-circle text-success"></i>
                                            </div>
                                            <div className="font-size-12">{zoomUser?.cust?.user?.email}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            {/* Show default Zoom link if email hasn't been sent yet */}
                            {(!emailSent || !joinUrl) && zoomUser?.zoom?.join_url && (
                                <div className="px-3 py-3 mb-3">
                                    <label htmlFor="message-text" className="form-label">
                                        <div className="mb-4 font-size-16">
                                            <p className="mb-0">Zoom meeting link has been sent to 
                                            <span className="fw-medium text-secondary"> {zoomUser?.cust?.user?.email}</span>
                                            </p>
                                        </div>
                                        <div>
                                            <p className="mb-0">
                                                The recipient can now join the meeting using the link below:
                                            </p>
                                        </div>
                                        <a href={zoomUser?.zoom?.join_url} target="_blank" rel="noopener noreferrer">
                                            <b>Click here to copy join meeting link</b>
                                        </a>
                                    </label>
                                </div>
                            )}

                            {/* Show after email is sent with the new link */}
                            {emailSent && joinUrl && (
                                <div className="px-3 py-3 mb-3">
                                    <label htmlFor="message-text" className="form-label">
                                        <div className="mb-4 font-size-16">
                                            <p className="mb-0">Zoom meeting link has been sent to 
                                            <span className="fw-medium text-secondary"> {zoomUser?.cust?.user?.email}</span>
                                            </p>
                                        </div>

                                        <div>
                                            <p className="mb-0">
                                                The recipient can now join the meeting using the link below:
                                            </p>
                                        </div>
                                        <a href={joinUrl} target="_blank" rel="noopener noreferrer">
                                            <b>Click here to copy join meeting link</b>
                                        </a>
                                    </label>
                            </div>
                            )}
                            <div className="d-flex justify-content-between align-items-center">
                                
                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-sm btn-primary"
                                        type="button"
                                        disabled={sending || sentOnce}
                                        onClick={() => handleSendZoomLink(
                                            zoomUser?.cust?.user?.id,
                                            zoomUser?.cust?.user?.email
                                        )}
                                    >
                                        {sending ? 'Sending...' : 'Send Link'}
                                    </button>

                                    {emailSent && startUrl && (
                                        <a
                                            href={startUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-sm btn-success"
                                        >
                                            Start Meeting
                                        </a>
                                    )}
                                </div>
                                {(!emailSent || !joinUrl) && zoomUser?.zoom?.join_url && (
                                    <label htmlFor="message-text" className="col-form-label">
                                        Having Troble to join link click Sent link
                                    </label>
                                )}
                            </div>
                        </form>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default ExpDashboard;
